import { render, staticRenderFns } from "./cModalAddFam.vue?vue&type=template&id=5805d256&scoped=true"
import script from "./cModalAddFam.vue?vue&type=script&lang=js"
export * from "./cModalAddFam.vue?vue&type=script&lang=js"
import style0 from "./cModalAddFam.vue?vue&type=style&index=0&id=5805d256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805d256",
  null
  
)

export default component.exports